import React from "react";
import { Select, MenuItem, Typography, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add"; // Import the "plus" icon
import styles from "./index.module.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const CustomDropdown = ({
  handleSelect,
  selectedValue,
  options,
  name,
  label,
  labelAdornment,
  onPlusClick,
  placeholder,
  addPlusIcon,
  isRequired,
  disabled,
  disablePlusIcon = false,
  minWidth,
  onOptionHover,
  onMenuClose,
  bgColour,
  error,
  helperText,
}) => {
  const isPlusDisabled = Boolean(disabled || disablePlusIcon);
  const menuProps = {
    PaperProps: {
      className: styles.menuPaper,
      sx: {
        width: "250px",
        left: "1047px",
      },
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
  };
  return (
    <Box className="custom-dropdown-container" sx={{ width: "100% !important" }}>
      {label && (
        <Typography
          sx={{
            fontSize: "0.9rem",
            color: "#555",
            marginBottom: "0",
          }}
          variant="subtitle1"
          gutterBottom
        >
          {label}{" "}
          <span className={styles.requiredSymbol}>{isRequired ? "*" : ""}</span>
          {labelAdornment}
        </Typography>
      )}
      <Box
        sx={{ width: "100%", minWidth: minWidth || "100%", display: "flex" }} // Used to be minwidth 220px not 100%, note in case breaks other areas of app 2026-02-12
      >
        <Select
          className={styles.dropdown}
          value={selectedValue || ""}
          onChange={(event) => handleSelect(event, name)}
          displayEmpty
          onClose={() => onMenuClose?.()}   
          MenuProps={menuProps}
          disabled={disabled}
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: `${label ? "0px" : "10px"}`,
            width: addPlusIcon ? "200px" : "100%",
            minWidth: addPlusIcon ? "200px" : "100%",
            gap: "5px",
            color: selectedValue ? "gray" : "#9e9e9e", // text color when value is selected
            "& .MuiSelect-select": {
              color: selectedValue ? "gray" : "#9e9e9e",
            },
            border: "1px solid rgba(0,0,0,0.23)",
            ...(error ? { borderColor: "#d32f2f" } : {}),
            backgroundColor: bgColour || "#FFFFFF",
            '& .Mui-disabled': {
              cursor: 'not-allowed'
            }
          }}
          renderValue={(value) => {
            // const selected = options?.find(option => option.id === value);
            console.log("value", value, options);
            // return selected?.name || `Select ${label || placeholder}`;
            const normalizedValue = Array.isArray(value) ? value[0] : value;
            const selected = options?.find((option) => option.id == normalizedValue);
            
            if (!selected) {
              if (normalizedValue !== null && normalizedValue !== undefined && normalizedValue !== "") {
                return String(normalizedValue);
              }
              return <span style={{ color: "#9e9e9e" }}>select</span>;
            }
            return selected.name;
          }}
          IconComponent={() => (
            <KeyboardArrowDownIcon className={styles.iconStyles} />
          )}
        >
          {/* {label && ( */}
          <MenuItem disabled className={styles.option} value={label}>
            {"select"}
          </MenuItem>
          {/* )} */}

          {options?.map((option, index) => (
            <MenuItem
            disabled={option?.disabled} 
            key={index} className={styles.option} value={option?.id}  onMouseEnter={() => onOptionHover?.(option.id)}>
              {option?.name}
            </MenuItem>
          ))}
        </Select>
        {addPlusIcon && (
          <Box
            className={styles.plusIconWrapper}
            onClick={(event) => {
              if (isPlusDisabled) {
                event.preventDefault();
                event.stopPropagation();
                return;
              }
              onPlusClick?.(event);
            }}
            aria-disabled={isPlusDisabled}
            sx={{
              marginTop: `${label ? "0px" : "10px"}`,
              opacity: isPlusDisabled ? 0.4 : 1,
              pointerEvents: isPlusDisabled ? "none" : "auto",
              cursor: isPlusDisabled ? "not-allowed" : "pointer",
            }}
          >
            <AddIcon className={styles.plusIcon} />
          </Box>
        )}
      </Box>
      {helperText ? (
        <Typography sx={{ mt: 0.5, fontSize: 12, color: error ? "#d32f2f" : "text.secondary" }}>
          {helperText}
        </Typography>
      ) : null}
    </Box>
  );
};

export default CustomDropdown;
